<template>
  <span class="request-code-cell">
    <span
      :id="triggerId"
      class="request-code-cell__trigger"
    >
      <a
        class="request-code-cell__link"
        :href="hrefData.href"
        target="_blank"
        rel="noopener noreferrer"
        :class="{ 'request-code-cell__link--reimbursement': types === 'reimbursement' }"
      >
        {{ hrefData.code }}
      </a>
    </span>
    <b-popover
      :target="triggerId"
      triggers="hover"
      placement="top"
      boundary="viewport"
      custom-class="request-code-cell-popover"
    >
      <template #title>
        <span class="request-code-cell-popover__title">
          <feather-icon
            icon="ExternalLinkIcon"
            size="14"
            class="request-code-cell-popover__icon"
          />
          Open Request
        </span>
      </template>
      <div class="request-code-cell-popover__body" />
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'RequestCodeCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    types: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      accessRole: localStorage.getItem('accessRole') || '',
      accessToken: localStorage.getItem('accessToken') || '',
      accessName: localStorage.getItem('name') || '',
      accessEmail: localStorage.getItem('email') || '',
    }
  },
  computed: {
    triggerId() {
      const id = this.data.item?.id ?? this.data.item?.request_id ?? Math.random().toString(36).slice(2)
      return `request-code-popover-${id}`
    },
    hrefData() {
      if (this.types === 'reimbursement') {
        return {
          code: this.data.item.request?.request_code || '',
          href: `https://ce.gulftic.com/orders/order/${this.data.item.request_id}?role=${this.accessRole}&name=${this.accessName}&email=${this.accessEmail}&token=${this.accessToken}`,
        }
      }
      return {
        code: this.data.item.request_code || '',
        href: `https://ce.gulftic.com/orders/order/${this.data.item.id}?role=${this.accessRole}&name=${this.accessName}&email=${this.accessEmail}&token=${this.accessToken}`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$violet:  #7c3aed;
$violet2: #5b21b6;
$indigo:  #4f46e5;

.request-code-cell {
  display: inline-block;
}

.request-code-cell__trigger {
  display: inline-block;
}

.request-code-cell__link {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  color: $violet2;
  text-decoration: none;
  white-space: nowrap;
  padding: 0.15rem 0.35rem;
  margin: -0.15rem -0.35rem;
  border-radius: 0.35rem;
  transition: color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    color: $violet;
    background: linear-gradient(135deg, rgba($violet, 0.1), rgba($indigo, 0.08));
    box-shadow: 0 1px 4px rgba($violet, 0.2);
  }

  &:focus {
    outline: none;
    color: $violet;
    background: linear-gradient(135deg, rgba($violet, 0.12), rgba($indigo, 0.1));
    box-shadow: 0 0 0 2px rgba($violet, 0.25);
  }

  &--reimbursement {
    color: #1e293b;

    &:hover {
      color: $violet2;
      background: linear-gradient(135deg, rgba($violet, 0.08), rgba($indigo, 0.06));
    }
  }
}
</style>

<!-- Popover is rendered in body so styles are unscoped -->
<style lang="scss">
$violet:  #7c3aed;
$violet2: #5b21b6;
$indigo:  #4f46e5;
$border:  #e2e8f0;
$muted:   #64748b;

.request-code-cell-popover.popover {
  .popover-header {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    background: linear-gradient(135deg, rgba($violet, 0.1), rgba($indigo, 0.08));
    border-bottom: 1px solid $border;
    border-radius: 0.35rem 0.35rem 0 0;
    font-weight: 700;
    font-size: 0.8rem;
    color: $violet2;
  }

  .popover-body {
    padding: 0.45rem 0.75rem;
    font-size: 0.78rem;
    color: $muted;
    line-height: 1.35;
  }
}

.request-code-cell-popover__title {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.request-code-cell-popover__icon {
  flex-shrink: 0;
  color: $violet;
}

.request-code-cell-popover__body {
  margin: 0;
}
</style>
